import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingContainer',
  props: {
    height: { default: "vh-50" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["align-items-center d-flex flex-fill justify-content-center", __props.height])
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("span", {
      class: "spinner-border spinner-border text-primary",
      role: "status",
      "aria-hidden": "true"
    }, null, -1)
  ]))], 2))
}
}

})